const ru = {
  contact: {
    heroHeading: 'Свяжитесь с нами',
    heroSub: 'Покупаете, продаёте или инвестируете — наша команда готова помочь на каждом шаге.',
    expertsBadge: 'Наши эксперты',
    expertsHeading: 'Команда Victory Homes',
    officeLabel: 'Адрес офиса',
    phoneLabel: 'Номера телефонов',
    phoneOffice: 'Офис',
    phoneWA: 'Звонок / WhatsApp',
    emailLabel: 'Напишите нам',
    followLabel: 'Подписывайтесь',
    formHeading: 'Отправьте сообщение',
    formSub: 'Заполните форму — мы ответим в течение 24 часов.',
    fieldName: 'Ваше имя *',
    fieldEmail: 'Адрес эл. почты *',
    fieldPhone: 'Номер телефона',
    fieldSubject: 'Тема',
    fieldMessage: 'Ваше сообщение *',
    sendBtn: 'Отправить',
    sentBtn: '\u2713 Отправлено!',
    thankYou: 'Спасибо! Мы ответим в течение 24 часов.',
  },
  mort: {
    heroBadge: 'Ипотечные услуги',
    heroLine1: 'Ипотечные решения в ОАЭ',
    heroAccent: 'Под ваши потребности',
    heroSub: 'Рассчитайте EMI, проверьте право на ипотеку и изучайте предложения 15+ банков ОАЭ — в одном месте.',
    tabCalc: '📊 Калькулятор ипотеки',
    tabElig: '✅ Проверка права',
    loanParams: 'Параметры кредита',
    propertyValue: 'Стоимость недвижимости',
    downPayment: 'Первоначальный взнос',
    annualRate: 'Годовая процентная ставка',
    loanTenure: 'Срок кредита',
    years: (n) => `${n} лет`,
    minDown: '20% (мин.)',
    maxUAE: '25 лет (макс. ОАЭ)',
    monthlyEMI: 'Ежемесячный платёж (EMI)',
    loanAmount: 'Сумма кредита',
    totalInterest: 'Сумма процентов',
    totalPayable: 'Итого к выплате',
    principalVsInterest: 'Основной долг вс. Проценты',
    principal: 'Основной долг',
    interest: 'Проценты',
    compareRates: '🏦 Сравнение ставок банков ОАЭ',
    amortSchedule: '📅 Годовой график погашения',
    basedOnLoan: (amt, yrs) => `На основе кредита ${amt} AED на ${yrs} лет. Ставки ориентировочные.`,
    bankCol: 'Банк',
    fixedRate3yr: 'Фиксированная (3 года)',
    variableEIBOR: 'Плавающая (EIBOR+)',
    monthlyEMIFixed: 'EMI (фикс.)',
    totalCost: 'Общая стоимость',
    eibor3mNote: (rate) => `* EIBOR 3М: ${rate}% (ориентир). Плавающие ставки пересматриваются периодически.`,
    yearCol: 'Год',
    principalPaid: 'Основной долг',
    interestPaid: 'Проценты',
    balanceRemaining: 'Остаток',
    yearRow: (n) => `Год ${n}`,
    financialProfile: 'Ваш финансовый профиль',
    residencyStatus: 'Статус проживания',
    residencyOpts: [
      { value: 'resident',    label: '🏠 Резидент ОАЭ',   desc: '80% LTV · 25 лет' },
      { value: 'national',    label: '🇦🇪 Гражданин ОАЭ',  desc: '85% LTV · 25 лет' },
      { value: 'nonresident', label: '✈️ Нерезидент',  desc: '50% LTV · 15 лет' },
    ],
    yourAge: 'Ваш возраст',
    ageUnit: 'лет',
    monthlySalary: 'Месячная зарплата (AED)',
    otherIncome: 'Другой доход',
    existingEMI: 'Существующие платежи (AED/мес.)',
    creditCard: 'Лимит кредитной карты (AED)',
    ccNote: 'Банки учитывают 5% лимита как ежемесячную нагрузку',
    assumedRate: 'Предполагаемая ставка',
    checkBtn: '🔍 Проверить право',
    fillDetails: 'Заполните данные',
    fillDesc: 'На основе правил ЦБ ОАЭ мы рассчитаем максимальную сумму кредита.',
    errTitle: 'Не удалось рассчитать право',
    errDesc: 'Ваши обязательства могут превышать 50% DBR. Обратитесь к нашим специалистам.',
    maxLoan: 'Макс. сумма кредита',
    maxProperty: 'Макс. стоимость',
    minDownPay: 'Мин. аванс',
    maxTenure: 'Макс. срок',
    maxEMI: 'Макс. платёж',
    dbrTitle: 'Анализ DBR ЦБ ОАЭ',
    grossIncome: 'Валовый доход',
    existingObligs: 'Текущие обязательства',
    dbrHeadroom: 'Запас DBR (50%)',
    ltvApplied: 'Применяемый LTV',
    dbrNote: 'Результаты ориентировочные. Фактическая право зависит от оценки банка.',
    readyApply: 'Готовы подать заявку?',
    readyApplyDesc: 'Наши специалисты обеспечат лучшую ставку в 15+ банках.',
    talkAdvisor: 'Связаться с консультантом →',
    servicesBadge: 'Наши услуги',
    servicesHeading: 'Всё необходимое под одной крышей',
    servicesSub: 'Victory Homes сотрудничает с ведущими банками ОАЭ для предоставления прозрачных ипотечных услуг.',
    services: [
      { icon: '🏠', title: 'Жилая ипотека', desc: 'Финансируйте дом мечты по конкурентным ставкам.' },
      { icon: '✈️', title: 'Ипотека для нерезидентов', desc: 'Живёте за рубежом И хотите инвестировать? Мы организуем ипотеку 50% LTV.' },
      { icon: '🔄', title: 'Рефинансирование / Вывод капитала', desc: 'Перейдите в другой банк и сэкономьте тысячи на процентах.' },
      { icon: '🏗️', title: 'Земля и строительство', desc: 'Специальные продукты для земельных участков и строительства.' },
      { icon: '📋', title: 'Бесплатная оценка право', desc: 'Оцениваем ваш профиль и выдаём предеквалификационное письмо 5+ банков.' },
      { icon: '👤', title: 'Персональный консультант', desc: 'Каждый клиент получает отдельного специалиста.' },
    ],
    ctaHeading: 'Готовы сделать следующий шаг?',
    ctaSub: 'Наши эксперты помогут заключить лучшую сделку. Бесплатная консультация.',
    ctaBtn: 'Записаться на консультацию →',
  },
  offplan: {
    heroBadge: '\u2726 Недвижимость Дубая на этапе строительства',
    heroLine1: 'Инвестируйте до того,',
    heroAccent: 'как это сделает город.',
    heroSub: 'Исключительный доступ к самым востребованным проектам Дубая. Зафиксируйте объекты по сегодняшним ценам — до движения рынка.',
    browseBtn: 'Обзор проектов',
    advisorBtn: 'Связаться с советником',
    statGrowth: 'Средний рост капитала',
    statVisa: 'Порог визы зола',
    statComm: 'Комиссия для покупателя',
    whyBadge: 'Почему на этапе строительства',
    whyHeading: 'Выбор умного инвестора',
    why: [
      { icon: '\ud83d\udcb0', title: 'Низкая цена входа', desc: 'Покупка по доланчным ценам — обычно 20–30% ниже рыночной стоимости после сдачи.' },
      { icon: '\ud83d\udcc5', title: 'Гибкие планы оплаты', desc: 'Застройщики предлагают схемы 40/60 или 20/80 — растяните инвестиции на весь период строительства.' },
      { icon: '\ud83d\udcc8', title: 'Рост капитала', desc: 'Недвижимость Дубая исторически обеспечивает 30–50% роста.' },
      { icon: '\ud83e\ude99', title: 'Доступ к золотой визе', desc: 'Объекты от 2 млн. ДХ дают право на 10-летнюю золотую визу.' },
    ],
    featuredBadge: 'Избранные проекты',
    featuredHeading: 'Отборные проекты на этапе строительства',
    catalogueLink: 'Запросить полный каталог \u2192',
    showingOf: (shown, total) => `Показано ${shown} из ${total} проектов`,
    noMatchTitle: 'Подходящих объектов не найдено',
    noMatchDesc: 'Попробуйте расширить поиск или изменить фильтры.',
    clearFilters: 'Сбросить фильтры',
    communitiesBadge: 'Исследовать районы',
    communitiesHeading: 'Наиболее популярные районы Дубая',
    seeListings: 'Все объявления \u2192',
    locations: [
      { name: 'Downtown', desc: ['В сердце Дубая, Downtown — квинтэссенция городской жизни.', 'Просторные лаунжи и панорамные террасы с видом на достопримечательности.'] },
      { name: 'Palm Jumeirah', desc: ['Пальм Джумейра — один из самых престижных адресов Дубая.', 'Продуманные резиденции и серенные пространства.'] },
      { name: 'Marina', desc: ['Дубай Марина — энергия города и южная роскошь на воде.', 'Частные марины и живописные набережные променады.'] },
      { name: 'Dubai Hills', desc: ['Дубай Хиллс — слияние природы и городского комфорта.', 'Жизнь, определённая здоровьем, рефайнментом и социальностью.'] },
      { name: 'Arabian Ranches', desc: ['Изысканные виллы и зелёные улицы.', 'Гольф-поля и парки для семейной жизни.'] },
    ],
  },
  sell: {
    heroBadge: 'Разместить объект',
    heroHeadline: 'Сотрудничайте с',
    heroAccent: 'Victory Homes',
    heroSub: 'Разместите объект с нашей командой для продажи или аренды. Мы ведём всё — от оценки до закрытия сделки.',
    formBadge: 'Для владельцев недвижимости',
    formHeading: 'Разместите объект с нами',
    formSub: 'Заполните форму и наша команда возьмёт на себя всё — от оценки до закрытия.',
    tabSell: '🏷️ Продать',
    tabRent: '🔑 Аренда',
    sectionContact: 'Контактные данные',
    sectionProperty: 'Детали объекта',
    sectionDocs: 'Юридические документы',
    sectionPhotos: 'Фотографии объекта',
    fullName: 'Полное имя',
    email: 'Электронная почта',
    phone: 'Номер телефона',
    whatsapp: 'WhatsApp (необязательно)',
    propertyType: 'Тип недвижимости',
    selectType: '— Выберите тип —',
    emirate: 'Эмират',
    selectEmirate: '— Выберите эмират —',
    community: 'Район / управляемое сообщество',
    subCommunity: 'Подрайон / Здание',
    bedrooms: 'Спальни',
    bathrooms: 'Ванные',
    select: '— Выберите —',
    areaSqFt: 'Площадь (кв. фут)',
    floor: 'Этаж',
    furnishing: 'Меблировка',
    completion: 'Статус объекта',
    ready: 'Готов',
    offPlan: 'Проектный',
    askingPrice: 'Цена продавца',
    rentAmount: 'Ставка аренды (в год)',
    priceHint: 'Введите сумму без запятых. Цена должна отражать рыночную стоимость.',
    youtubeLink: 'Ссылка на видео YouTube',
    youtubeHint: 'Добавьте ссылку на YouTube, чтобы показать свою недвижимость (необязательно)',
    description: 'Описание объекта',
    descPlaceholder: 'Опишите объект — особенности, виды, улучшения, рядом расположенные удобства…',
    docsIntro: 'Эти документы подтверждают права собственности. Все файлы хранятся безопасно.',
    titleDeed: 'Свидетельство о собственности',
    titleDeedHint: 'Официальный документ о собственности.',
    floorPlan: 'План этажа',
    floorPlanHint: 'Архитектурный план этажа.',
    passport: 'Копия паспорта',
    passportHint: 'Действующий паспорт владельца.',
    privacy: 'Конфиденциальность гарантирована. Документы зашифрованы и доступны только нашей команде.',
    photosLabel: 'Фотографии объекта',
    photosHint: 'До 20 фото — JPG, PNG, WEBP. Первая фото — обложка.',
    photosIntro: 'Качественные фото вдвое увеличивают число заявок. Съемка всех комнат широкоугольным объективом.',
    dragDrop: 'Перетащите или',
    browse: 'выберите',
    accepted: 'PDF, JPG, PNG принимаются',
    clickReplace: 'Нажмите, чтобы заменить',
    dropPhotos: 'Перетащите фото сюда',
    orClickBrowse: 'или нажмите для выбора',
    upTo20: 'До 20 фото',
    photosAdded: (n) => `Добавлено ${n} фото`,
    submitSale: '🚀 Отправить объявление о продаже',
    submitRental: '🚀 Отправить объявление об аренде',
    submitting: '⏳ Отправка…',
    termsNotice: 'Отправляя, вы соглашаетесь с Условиями обслуживания Victory Homes.',
    successTitle: 'Объявление отправлено!',
    successDesc: 'Наша команда рассмотрит и свяжется с вами в течение',
    successHours: '24 часов',
    submitAnother: 'Отправить ещё',
    errName: 'Полное имя обязательно',
    errEmail: 'Требуется корректный email',
    errPhone: 'Номер телефона обязателен',
    errPropType: 'Выберите тип',
    errEmirate: 'Выберите эмират',
    errPrice: 'Цена обязательна',
    errRent: 'Ставка аренды обязательна',
    errPhotos: 'Ребуется хотя бы одна фотография',
  },
  props: {
    heroBadge: 'Недвижимость ОАЭ',
    listingCount: (n) => `${n} объявлений доступно`,
    tabBuy: 'Купить',
    tabRent: 'Аренда',
    portfolio: 'Наш портфель',
    forSale: 'Недвижимость на продажу',
    forRent: 'Недвижимость в аренду',
    listYourProperty: 'Разместить объект →',
    buy: {
      badge: 'Недвижимость на продажу',
      headline: 'Найдите свою',
      accent: 'Идеальную недвижимость',
      sub: 'Изучите проверенные объявления о продаже, отобранные нашей командой в ОАЭ.',
    },
    rent: {
      badge: 'Недвижимость в аренду',
      headline: 'Найдите свою',
      accent: 'Идеальную аренду',
      sub: 'Просматривайте объявления об аренде от Victory Homes в Дубае и ОАЭ.',
    },
    enquireNow: 'Спросить сейчас →',
    noMatchTitle: 'Ничего не найдено по вашим фильтрам',
    noMatchDesc: 'Попробуйте изменить бюджет, тип или район.',
    clearFilters: 'Сбросить фильтры',
    emptyBuy: 'Сейчас нет объектов в продаже',
    emptyRent: 'Сейчас нет объектов в аренду',
    emptyDesc: () => 'Наш портфель регулярно обновляется — проверьте снова скоро или свяжитесь с нами напрямую.',
    speakAgent: 'Связаться с агентом →',
    listProp: 'Разместить объект',
    exploreOther: 'Другие объекты',
    otherForSale: 'Другие доступные объекты на продажу',
    otherForRent: 'Другие доступные объекты в аренду',
    otherDesc: 'Пока мы пополняем эту категорию, вот другие объекты из нашего портфеля.',
    ctaBadge: 'Готовы разместить?',
    ctaHeading: 'Есть объект для размещения?',
    ctaDesc: 'Наши эксперты берут на себя всё — от оценки до закрытия сделки. Разместите объект с Victory Homes сегодня.',
    contactUs: 'Связаться',
  },
  featured: {
    tag: 'Эксклюзивная недвижимость',
    heading: 'Откройте эксклюзивную недвижимость вместе с Emirates',
    desc: 'Откройте лучший выбор роскошного жилья и ведущих возможностей на рынке недвижимости вместе с Emirates. Войдите в жизнь, которой вы заслуживаете.',
  },
  partners: {
    tag: 'Наши партнёры',
    heading: 'Объекты от ведущих застройщиков ОАЭ',
    learnMore: 'Подробнее',
    learnMoreArrow: 'Подробнее →',
    oasis: { title: 'Oasis Garden Villas', desc: 'Просторные современные дома с собственными садами, затенёнными двориками и природными планировками — для спокойствия, элегантности и семейной жизни.' },
    ghaf:  { title: 'Ghaf Woods, Дубай', desc: 'Малоэтажный жилой квартал с экологичными домами, пешеходными пространствами и пышной зеленью — для здорового образа жизни.' },
    nad:   { title: 'Над аль-Шаба', desc: 'Эксклюзивный жилой район с просторными виллами в спокойной среде, известный конфиденциальностью, зеленью и близостью к ключевым достопримечательностям Дубая.' },
    district: { title: 'District One, Дубай', desc: 'Сверхлюксозное спланированное сообщество с элегантными виллами и особняками у кристальных лагун и зелёных пространств — для уединения и престижа.' },
  },
  media: {
    tag: 'Упоминания в СМИ',
    heading: 'В центре внимания прессы',
    readArticle: 'Читать статью',
  },
  newsletter: {
    badge: 'Будьте в курсе',
    heading: 'Держите руку на пульсе рынка недвижимости Дубая',
    desc: 'Эксклюзивные листинги, аналитика рынка и инвестиционные возможности прямо в ваш почтовый ящик — раньше, чем они выйдут на рынок.',
    placeholder: 'Введите адрес электронной почты',
    btn: 'Подписаться →',
    privacy: '🔒 Никакого спама. Отписка в любое время. Ваши данные в безопасности.',
    success: '✓ Вы подписаны! Добро пожаловать в сообщество Victory Homes.',
    error: 'Пожалуйста, введите корректный адрес электронной почты.',
  },
  nav: {
    home: 'Главная', properties: 'Недвижимость', buy: '🏡 Купить', rent: '🔑 Аренда',
    sellRent: 'Продать/Сдать', offplan: 'Строящиеся', services: 'Услуги',
    holidayHomes: 'Дома для отпуска', propertyManagement: 'Управление недвижимостью',
    fitOut: 'Ремонт, переезд и упаковка',
    legalAssistance: 'Юридическая помощь',
    valuation: 'Оценка недвижимости',
    calculators: 'Ипотека',
    transactions: 'Транзакции',
    mortgage: 'Ипотечный калькулятор', contact: 'Связаться', roiCalc: 'Калькулятор ROI',
    areaIntelligence: 'Анализ Районов',
  },
  valuation: {
    heroTitle: 'Бесплатная рыночная оценка недвижимости',
    heroDesc: 'Думаете о продаже? Получите мгновенную оценку текущей рыночной стоимости от наших экспертов.',
    successTitle: 'Запрос получен!',
    successDesc: 'Наши эксперты по оценке рассмотрят детали вашей недвижимости и свяжутся с вами в ближайшее время.',
    submitAnother: 'Отправить еще',
    fullName: 'Полное имя *',
    phone: 'Номер телефона *',
    email: 'Адрес электронной почты',
    propType: 'Тип недвижимости *',
    selectType: 'Выберите тип',
    location: 'Расположение / Район *',
    locPlaceholder: 'например, Дубай Марина',
    bedrooms: 'Спальни',
    select: 'Выбрать',
    area: 'Площадь (Sq.Ft)',
    areaPlaceholder: 'например, 1500',
    submit: 'Получить бесплатную оценку',
    submitting: 'Отправка...',
    fail: 'Не удалось отправить запрос. Пожалуйста, попробуйте еще раз.'
  },
  recentlySold: {
    title: 'Недавно проданная недвижимость',
    desc: 'Выбор наших последних успешных сделок. Почувствуйте разницу с Victory Homes.',
    badge: 'Продано',
    beds: 'Кровати'
  },
  trust: {
    clientStories: 'Истории клиентов',
    hearFromClients: 'Отзывы наших клиентов',
    videoUnavailable: 'Видео недоступно',
    trackRecord: 'Послужной список',
    provenSuccess: 'Доказанный успех'
  },
  areaIntelligence: {
    heroBadge: 'Аналитика районов Дубая',
    heroLine1: 'Данные и инсайты для каждого',
    heroAccent: 'Района Дубая.',
    heroSub: 'Изучайте ценовые тренды, доходность аренды и ИИ-аналитику по самым востребованным районам Дубая.',
    modeBuy: 'Купить',
    modeRent: 'Аренда',
    modeOffplan: 'Строящиеся',
    filterTitle: 'Фильтры и метрики',
    heatmapLabel: 'Метрика карты',
    chartAreasLabel: 'Районы для графиков',
    selectAll: 'Все',
    selectNone: 'Ни один',
    loading: 'Загрузка данных районов…',
    mapsKeyMissing: 'Требуется ключ Google Maps API',
    mapsKeyHint: 'Добавьте VITE_GOOGLE_MAPS_API_KEY в файл .env и перезагрузите страницу.',
    mapFailedLoad: 'Ошибка загрузки карты. Проверьте ключ API.',
    mapLoading: 'Загрузка карты…',
    legendSelectedArea: '⬤ Выбранный район',
    legendSelectedDesc: 'Белый пузырь = ваш активный выбор',
    legendLow: { avgPrice: 'Низкая цена', rentalYield: 'Низкая доходность', demandScore: 'Низкий спрос', avgPricePerSqft: 'Низкая цена/кв.фут' },
    legendHigh: { avgPrice: 'Высокая цена', rentalYield: 'Высокая доходность', demandScore: 'Высокий спрос', avgPricePerSqft: 'Высокая цена/кв.фут' },
    activeProjects: 'Активные проекты',
    nearbyLandmarks: '📍 Достопримечательности рядом',
    kpiAvgPrice: 'Средняя цена',
    kpiPricePerSqft: 'Цена / кв.фут',
    kpiGrossYield: 'Валовая доходность',
    kpiDemandScore: 'Индекс спроса',
    aiInsightTitle: '✦ ИИ-аналитика рынка',
    aiGenerate: 'Сгенерировать →',
    aiAnalysing: 'Анализируем данные рынка…',
    aiKeyMissing: 'Добавьте GEMINI_API_KEY в backend/.env для активации ИИ-анализа.',
    aiPrompt: 'Нажмите «Сгенерировать» для ИИ-анализа инвестиций в этом районе.',
    browseOffplan: (name) => `Строящиеся в ${name} →`,
    viewResale: 'Объекты вторичного рынка →',
    priceTrendBadge: 'Ценовой тренд',
    priceTrendTitle: 'Цена за кв.фут за 12 месяцев (AED)',
    priceTrendSub: '12-месячный тренд на основе агрегированных данных рынка',
    rentalYieldBadge: 'Доходность аренды',
    rentalYieldTitle: 'Валовая доходность аренды по районам (%)',
    rentalYieldSub: 'На основе средней годовой аренды vs средней цены покупки',
    tooltipYield: (val, name) => [`${val}% валовая доходность`, name],
    comparisonBadge: 'Сравнение районов',
    comparisonTitle: 'Сравнить до 3 районов',
    comparisonSub: 'Выберите районы ниже для сравнения рядом',
    comparisonPlaceholder: 'Выберите районы выше, чтобы увидеть сравнение',
    colMetric: 'Метрика',
    rowAvgPrice: 'Средняя цена',
    rowPricePerSqft: 'Цена / кв.фут',
    rowGrossYield: 'Валовая доходность',
    rowDemandScore: 'Индекс спроса',
    rowActiveProjects: 'Активные проекты',
    rowMinEntry: 'Мин. цена входа',
    rowMaxPrice: 'Макс. цена',
    best: 'Лучший',
    metricAvgPrice: 'Средняя цена',
    metricRentalYield: 'Доходность аренды',
    metricDemand: 'Спрос',
    metricPricePerSqft: 'Цена/кв.фут',
  },
  hero: {
    slide1H: 'Там, где умные данные, профессиональное руководство и доверие объединяются.',
    slide1P: 'Victory Homes — первый брокер ОАЭ, помогающий людям найти образ жизни мечты ещё до выбора дома.',
    slide1Btn: 'Узнать больше',
    slide2H: 'Эксклюзивная недвижимость у воды.',
    slide2P: 'Ощутите непревзойдённую роскошь на самом знаменитом рукотворном острове мира — Palm Jumeirah.',
    slide2Btn: 'Изучить Palm',
    slide3H: 'Жизнь будущего, идеальное совпадение.',
    slide3P: 'Используя экологические данные и прогностическое моделирование, мы соединяем людей с передовыми сообществами в Dubai Marina.',
    slide3Btn: 'Открыть Marina',
    slide4H: 'Найдите жизнь, а не только дом.',
    slide4P: 'Откройте для себя частное убежище в окружении легендарной Crystal Lagoon и зелёных просторов District One.',
    slide4Btn: 'Смотреть District One',
  },
  stats: {
    impact: 'Наш деловой вклад',
    sold: 'Всего продано 2020–2024',
    lifetime: 'Совокупный объём продаж',
    current: 'Текущий объём листинга',
  },
  sellTestimonials: {
    tag: 'Отзывы клиентов',
    heading: 'Продайте с Victory Homes — быстро и эффективно',
    desc: 'Прозрачный процесс для максимальной стоимости вашей недвижимости с минимумом стресса.',
  },
  team: {
    tag: 'Наша команда',
    heading: 'Познакомьтесь с ведущими экспертами по недвижимости Эмирата',
    desc: 'Наши опытные агенты Victory Homes готовы сопроводить вас на каждом этапе сделки.',
    btn: 'Познакомиться со всей командой →',
  },
  goldenVisa: {
    badge: '🇦🇪 Преимущества инвестора',
    heading: 'Золотая виза ОАЭ',
    headingGold: 'Через недвижимость',
    desc: 'Инвестируйте в недвижимость ОАЭ на сумму <strong>от 2 000 000 дирхам</strong> и получите <strong>10-летний вид на жительство</strong> — для вас и вашей семьи.',
    cta: 'Проверить право на визу →',
    benefitsHeading: 'Почему Золотая виза меняет правила игры',
    benefitsSubheading: 'Золотая виза ОАЭ открывает двери, недоступные в большинстве стран мира.',
    stepsHeading: 'Как получить Золотую визу',
    stepsSubheading: '4 простых шага — наша команда сопроводит вас на каждом',
    stepCtaHeading: 'Готовы оформить Золотую визу ОАЭ?',
    stepCtaDesc: 'Наши консультанты подберут подходящую недвижимость под ваш бюджет и цели.',
    stepCtaBtn: 'Проконсультироваться',
    yearVisa: 'Лет — срок визы',
    minValue: 'Минимальная стоимость объекта',
    benefits: {
      b1t: '10-летнее ВНЖ', b1d: 'Оформите ВНЖ ОАЭ на 10 лет, инвестировав в недвижимость от 2 млн AED.',
      b2t: 'Спонсирование семьи', b2d: 'Включите супруга, детей и родителей в одну визу без отдельных заявлений.',
      b3t: 'Без спонсора', b3d: 'Живите, работайте и учитесь в ОАЭ без работодателя или местного спонсора.',
      b4t: 'Неограниченное продление', b4d: 'Пока вы владеете объектом, Золотая виза продлевается автоматически.',
      b5t: 'Глобальная мобильность', b5d: 'Многократные въезды и длительные поездки за рубеж без потери визы.',
      b6t: 'Безопасность инвестиций', b6d: 'Недвижимость ОАЭ — актив первого уровня с высоким потенциалом роста капитала.',
    },
    steps: {
      s1: 'Приобретите объект стоимостью от 2 млн AED',
      s2: 'Получите свидетельство о праве собственности в Земельном департаменте Дубая',
      s3: 'Подайте заявку через ICA или GDRFA при поддержке нашей команды',
      s4: 'Получите 10-летнюю Золотую визу и Emirates ID',
    },
  },
  blog: {
    tag: 'Блог',
    heading: 'Аналитика и новости от блога недвижимости Эмирата',
    desc: 'Актуальные новости рынка, советы и экспертные материалы о рынке недвижимости Дубая.',
    readMore: 'Читать далее',
  },
  evo: {
    statsBadge: 'Дубай в цифрах',
    statsHeading: 'Эволюция рынка недвижимости Дубая',
    statsDesc: 'Из регионального торгового порта — в самый динамичный рынок недвижимости мира за два десятилетия.',
    timelineBadge: 'История',
    timelineHeading: 'Как Дубай стал направлением №1 для инвестиций в недвижимость',
    timelineCTA: 'Хотите понять, куда движется рынок Дубая?',
    timelineBtn: 'Поговорить с экспертом рынка →',
    stats: {
      s1l: 'сделок с недвижимостью в 2024', s2l: 'AED — совокупный объём продаж 2024',
      s3l: 'рост цен на недвижимость с 2020', s4l: 'национальностей живёт в Дубае',
    },
    timeline: {
      t1t: 'Закон о фрихолде', t1d: 'Дубай разрешил иностранцам владеть недвижимостью в специальных зонах.',
      t2t: 'Преображение горизонта', t2d: 'Открылся Бурдж-Халифа. Дубай стал самым узнаваемым современным городом мира.',
      t3t: 'Запуск Золотой визы', t3d: 'ОАЭ запустили программу 10-летней Золотой визы, усилив спрос на жильё от 2 млн AED.',
      t4t: 'Рекордный рынок', t4d: 'После пандемии цены выросли более чем на 60% — лучший результат в мире.',
      t5t: 'Новые исторические максимумы', t5d: 'В Дубае зафиксировано более 96 000 сделок на сумму 411 млрд AED.',
      t6t: 'Генплан Дубай 2040', t6d: 'План предусматривает удвоение зелёных зон и население 5,8 млн человек к 2040 году.',
    },
  },
  txn: {
    badge: 'При поддержке DXBinteract',
    heading: 'Отчёты о сделках в Дубае',
    desc: 'Доступ к актуальным данным Земельного департамента Дубая — каждая продажа, каждая цена, каждый тренд.',
    live: 'Данные DLD в реальном времени',
    openPlatform: 'Открыть полную платформу ↗',
    viewReport: 'Смотреть отчёт →',
    ctaHeading: 'Нужен персональный отчёт по конкретному району?',
    ctaDesc: 'Наши консультанты извлекут данные по нужному району и интерпретируют их для вашей инвестиции.',
    ctaBtn: 'Спросить консультанта',
    reports: {
      r1l: 'Ежедневный отчёт', r1d: 'Все сделки DLD — обновление ежедневно.',
      r2l: 'Еженедельный отчёт', r2d: 'Еженедельный обзор объёмов, цен и тенденций по районам.',
      r3l: 'Ежемесячный отчёт', r3d: 'Углублённый анализ ежемесячных показателей по всем типам..',
      r4l: 'Квартальный отчёт', r4d: 'Поквартальный анализ: изменения цен, топ-районы, активность инвесторов.',
      r5l: 'Годовой отчёт', r5d: 'Годовой обзор рынка: рекордные сделки, новые районы, прогноз.',
      r6l: 'Карта цен по районам', r6d: 'Интерактивная тепловая карта с ценой за кв. фут по всем сообществам Дубая.',
    },
  },
  cta: {
    buying: 'Начать покупку', selling: 'Начать продажу', contact: 'Связаться',
    findOut: 'Узнать больше', comingSoon: 'Скоро',
  },
  offplanPromo: {
    badge: 'Строящаяся недвижимость',
    heading: 'Новые проекты и эксклюзивные предпродажные предложения',
    desc: 'Бронируйте квартиры в самых востребованных новостройках Дубая — пока они не раскуплены. Золотая виза от 2 млн AED.',
    btn: 'Изучить строящиеся →',
  },
  topCommunities: {
    badge: 'Аналитика рынка',
    heading: 'Топовые районы Дубая',
    desc: 'Стратегические инсайты для инвесторов и покупателей (2026-2027)',
    tabs: {
      roi: 'Лидеры по доходности (ROI)',
      villas: 'Виллы и Таунхаусы',
      budget: 'По бюджету',
      strategy: 'Руководство по стратегии'
    },
    roi: {
      title: 'Лучшие районы для ROI (2026–2027)',
      desc: 'Эти районы стабильно обеспечивают высокую арендную доходность и прирост капитала.',
      list: [
        'Jumeirah Village Circle (JVC)',
        'Dubai South',
        'Arjan',
        'Dubai Silicon Oasis',
        'Dubai Sports City',
        'Business Bay',
        'Dubai Marina'
      ],
      insightTitle: 'Ключевой инсайт',
      insights: [
        'JVC + Arjan = самая высокая доходность (6–9%)',
        'Marina + Business Bay = доходность ниже, но сильнее прирост капитала + ликвидность'
      ]
    },
    villas: {
      title: 'Лучшие районы для вилл / таунхаусов',
      desc: 'Ориентированы на семьи и долгосрочное проживание.',
      list: [
        'Dubai Hills Estate',
        'Arabian Ranches',
        'Tilal Al Ghaf',
        'DAMAC Hills',
        'The Valley',
        'Mudon',
        'Town Square'
      ],
      insightTitle: 'Ключевой инсайт',
      insights: [
        'Dubai Hills = лучший баланс (локация + качество)',
        'Tilal Al Ghaf = премиальный образ жизни',
        'Town Square / Valley = виллы базового уровня'
      ]
    },
    budget: {
      title: 'Лучшие районы по бюджету',
      categories: [
        {
          name: 'Базовый уровень',
          range: '500К – 900К AED',
          areas: ['International City', 'Dubai South', 'Discovery Gardens', 'Dubai Production City', 'Liwan'],
          bestFor: 'Первые инвестиции, высокая арендная доходность'
        },
        {
          name: 'Средний сегмент',
          range: '900К – 2М AED',
          areas: ['Jumeirah Village Circle', 'Arjan', 'Al Furjan', 'Dubai Silicon Oasis', 'Dubai Creek Harbour'],
          bestFor: 'Баланс ROI + прироста капитала'
        },
        {
          name: 'Выше среднего / Премиум',
          range: '2М – 5М AED',
          areas: ['Business Bay', 'Dubai Marina', 'Dubai Hills Estate', 'Palm Jumeirah (начальные лоты)'],
          bestFor: 'Ликвидность + высокий спрос на перепродаже'
        },
        {
          name: 'Люкс',
          range: '5М+ AED',
          areas: ['Downtown Dubai', 'Palm Jumeirah', 'Emirates Hills', 'District One', 'Jumeirah Bay Island'],
          bestFor: 'Сохранение капитала + престижные активы'
        }
      ]
    },
    strategy: {
      title: 'Простое руководство по стратегии',
      guide: [
        { goal: 'Максимальный ROI', action: 'JVC, Arjan, Dubai South' },
        { goal: 'Безопасные инвестиции', action: 'Dubai Hills, Marina' },
        { goal: 'Люкс и прирост капитала', action: 'Palm Jumeirah, Downtown' },
        { goal: 'Для жизни с семьей', action: 'Arabian Ranches, Tilal Al Ghaf' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "Услуги Victory",
    "whyChoose": "Почему выбирают наши {service}?",
    "form": {
        "fullName": "Полное Имя",
        "email": "Email Адрес",
        "phone": "Номер Телефона",
        "detailsOpt": "Сведения об объекте (необязательно)",
        "messageOpt": "Дополнительное сообщение или требования",
        "submitRequest": "Отправить Запрос",
        "submitting": "Отправка...",
        "successTitle": "Запрос Получен!",
        "successDesc": "Спасибо за обращение по поводу {service}. Наша команда свяжется с вами в ближайшее время.",
        "submitAnother": "Отправить еще один запрос",
        "errors": {
            "nameReq": "Пожалуйста, введите ваше имя",
            "emailReq": "Пожалуйста, введите действительный email",
            "phoneReq": "Пожалуйста, введите ваш номер телефона",
            "failSub": "Не удалось отправить запрос. Пожалуйста, попробуйте позже."
        },
        "placeholders": {
            "name": "напр. Иван Иванов",
            "email": "you@example.com",
            "phone": "+971 50 123 4567",
            "details": "напр. 2-комнатная квартира в Downtown Dubai",
            "message": "Как мы можем вам помочь?"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "Дома Для Отдыха",
            "heroSub": "Максимизируйте доход от вашей недвижимости с нашим управлением краткосрочной арендой.",
            "desc": "Превратите свою недвижимость в прибыльный отпускной дом без лишних хлопот. Мы занимаемся маркетингом, управлением гостями и обслуживанием.",
            "extraDesc": "От меблировки до профессиональной фотосъемки и оптимизированных объявлений. Мы обеспечиваем круглосуточную поддержку гостей 24/7.",
            "points": [
                "Динамическое ценообразование и маркетинг",
                "Круглосуточная поддержка гостей 24/7",
                "Профессиональная уборка",
                "Ежемесячная отчетность по ROI",
                "Юридическая помощь и регистрация"
            ],
            "formTitle": "Запрос услуг для домов отдыха",
            "formDesc": "Расскажите, как мы можем помочь с вашими целями аренды."
        },
        "property-management": {
            "title": "Управление Недвижимостью",
            "heroSub": "Комплексные услуги управления для вашей уверенности и стабильного дохода.",
            "desc": "От проверки арендаторов до запросов на техническое обслуживание - наша команда профессионально управляет вашими инвестициями.",
            "extraDesc": "Наша услуга охватывает всё: от регистрации в Ejari и сбора арендной платы до регулярных инспекций и экстренного ремонта.",
            "points": [
                "Комплексная проверка арендаторов",
                "Сбор аренды и финансовая отчетность",
                "Регистрация Ejari и соблюдение законов",
                "Регулярные проверки и обслуживание",
                "Услуги по разрешению споров"
            ],
            "formTitle": "Запрос на управление недвижимостью",
            "formDesc": "Предоставьте свои контактные данные, и мы свяжемся с вами."
        },
        "fit-out": {
            "title": "Услуги по Ремонту (Fit-Out)",
            "heroSub": "Преобразите ваше пространство с нашими решениями в области дизайна интерьера.",
            "desc": "Индивидуальный дизайн, планирование и реализация для жилых и коммерческих помещений.",
            "extraDesc": "Наши опытные дизайнеры и руководители проектов работают с вами от концепции до завершения, гарантируя премиальные материалы.",
            "points": [
                "Индивидуальные концепции дизайна",
                "Планирование пространства и 3D визуализация",
                "Реализация \"Под ключ\" и управление",
                "Официальные разрешения и согласования",
                "Поставка мебели и материалов"
            ],
            "formTitle": "Запрос на консультацию по fit-out",
            "formDesc": "Назначьте консультацию, чтобы обсудить ваше видение."
        },
        "legal-assistance": {
          title: "Юридическая помощь",
          heroSub: "Экспертное юридическое руководство для безопасных сделок с недвижимостью в ОАЭ.",
          desc: "Ориентация в законах Дубая о недвижимости требует точности. Мы предоставляем полную юридическую поддержку.",
          extraDesc: "От тщательной проверки правового титула до обеспечения полного соответствия RERA, наши эксперты защищают ваши интересы.",
          points: ["Проверка правового титула и Due Diligence", "Соответствие RERA", "Подготовка договора купли-продажи", "Проверка покупки недвижимости", "Разрешение споров"],
          formTitle: "Запросить юридическую помощь",
          formDesc: "Предоставьте свои данные, и наши юристы свяжутся с вами."
        }
    }
},
  footer: {
    letsWork: 'Давайте работать вместе',
    email: 'Электронная почта',
    callWhatsApp: 'Звонок / WhatsApp',
    ourLocation: 'Наш офис',
    officePhone: 'Телефон офиса',
    tagline: 'Ваш надёжный партнёр по недвижимости в Дубае. Специализируемся на купле, продаже и аренде премиальной недвижимости по всему ОАЭ.',
    ourServices: 'Наши услуги',
    usefulLinks: 'Полезные ссылки',
    copyright: '© 2025 Victory Homes. Все права защищены.',
    serviceLinks: ['Новая недвижимость', 'Продать объект', 'Наши услуги', 'Пресс-релиз'],
    headline: 'Наша команда квалифицированных агентов готова помочь вам всегда и везде.',
  },
  offplanDetail: {
    overview: "Обзор",
    propertyTypes: "Типы недвижимости",
    totalUnits: "Всего объектов",
    handover: "Сдача",
    startingPrice: "Начальная цена",
    startingFrom: "Начиная от",
    paymentPlan: "План оплаты",
    location: "Расположение и транспорт",
    mins: "Мин",
    unitType: "Тип объекта",
    size: "Площадь",
    availableOptions: "Доступные варианты",
    getBrochure: "Получить брошюру",
    reqDetails: "Запросить детали",
    dlBrochure: "Скачать брошюру",
    dlFloorPlans: "Скачать планировки",
    fullName: "Полное имя *",
    emailAdd: "Email адрес *",
    phoneNum: "Номер телефона",
    reqDesc: "Заполните данные для получения {type} по проекту {name}.",
    reqSuccess: "Заявка получена",
    reqSuccessDesc: "Спасибо. Наш специалист скоро отправит вам брошюру и планировки.",
    close: "Закрыть",
    submitting: "Отправка...",
    reqType: "Запросить {type}",
    types: {
        Apartment: "Апартаменты",
        Townhouse: "Таунхаус",
        Villa: "Вилла",
        Penthouse: "Пентхаус",
        Mansion: "Особняк",
        Duplex: "Дуплекс",
        Plot: "Участок"
    },
    tags: {
        waterfront: "У воды",
        family: "Для семьи",
        luxury: "Премиум",
        investment: "Инвестиции",
        golf: "Гольф",
        urban: "Городской",
        nature: "Природа"
    },
    beds: {
        studio: "Студия",
        br: "Спален",
        units: "Юнитов",
        various: "Различные"
    }
}
,
  offplanExtra: {
        "interested": "Заинтересованы?",
        "readyToSecure": "Готовы забронировать объект в",
        "advisorGuide": "Наши специалисты помогут вам разобраться с ценами, вариантами оплаты и всем процессом покупки — без комиссии.",
        "getInTouch": "Связаться с нами",
        "whatsapp": "WhatsApp",
        "enquire": "Узнать подробности",
        developer: "Застройщик",
    community: "Район",
    buildingHeight: "Высота здания",
    retailSpace: "Торговые площади",
    furnishing: "Меблировка",
    about: "О проекте",
    investmentOutlook: "Инвестиционная привлекательность",
    lifestyle: "Стиль жизни",
    worldClassAmenities: "Удобства мирового класса",
    unitTypes: "Типы объектов",
    floorPlans: "Планировки",
    financing: "Финансирование",
    typesSuffix: "Типы",
    sizeRange: "Площадь",
    units: "Юнитов",
    from: "От",
        ofTotalPayment: "от общей суммы",
        whyOffPlan: "Почему на стадии строительства?",
        lowerEntryPrice: "Более низкая цена по сравнению с готовой недвижимостью",
        spreadPayments: "Распределение платежей на период строительства",
        capitalAppreciation: "Рост стоимости до сдачи",
        zeroCommission: "Комиссия 0% — прямая покупка",
        speakToAdvisor: "Связаться с консультантом",
        openMap: "Открыть точное местоположение в Google Maps",
        nearbyPlaces: "Рядом находятся",
        to: "до",
        booking: "Бронирование",
        installment: "Взнос",
        handover: "Сдача",
        areaUnit: "Единица площади",
        currency: "Валюта",
        youtubeLink: "Ссылка на видео YouTube",
        watchVideo: "Смотреть видео",
        watchTour: "Смотреть тур по недвижимости"
    },
  amenities: {
        "Kids Pool": "Детский бассейн",
        "Private Beach Access": "Частный пляж",
        "Marina Access": "Доступ к пристани",
        "Outdoor Gym": "Тренажерный зал на открытом воздухе",
        "Basketball Court": "Баскетбольная площадка",
        "Tennis Court": "Теннисный корт",
        "Padel Court": "Падель-корт",
        "Cycling Track": "Велосипедная дорожка",
        "Spa & Wellness Center": "Спа и оздоровительный центр",
        "Kids Play Area": "Детская игровая площадка",
        "Clubhouse": "Клубный дом",
        "Library": "Библиотека",
        "Retail Outlets": "Торговые точки",
        "Cafes & Restaurants": "Кафе и рестораны",
        "Supermarket": "Супермаркет",
        "Concierge Service": "Консьерж-сервис",
        "24/7 Security": "Круглосуточная охрана",
        "CCTV Surveillance": "Видеонаблюдение",
        "Mosque": "Мечеть",
        "Pet Friendly": "Разрешено проживание с животными",
        "Dining Destinations": "Рестораны",
        "Yoga Studio": "Студия йоги",
        "Lush Green Parks": "Зеленые парки",
        "Valet Parking": "Услуги парковщика",
        "Smart Home Features": "Система 'Умный дом'",
        "Sauna & Steam Room": "Сауна и паровая баня",
        "Covered Parking": "Крытая парковка",
        "Landscaped Gardens": "Ландшафтные сады",
    "Swimming Pool": "Бассейн",
    "State-of-the-art Gym": "Современный спортзал",
    "BBQ Area": "Зона барбекю",
    "Sports Courts": "Спортивные площадки",
    "Infinity Pool": "Инфинити-бассейн",
    "Running Track": "Беговая дорожка",
    "Cinema Room": "Кинозал",
    "Games Room": "Игровая комната"
}
}

export default ru
